export const common = {
  actions: {
    cancel: 'Cancel',
    delete: 'Delete',
    create: 'Create',
    save: 'Save',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    add: 'Add',
    remove: 'Remove',
    search: 'Search',
    upload: 'Upload',
    download: 'Download',
    send: 'Send',
    retry: 'Retry',
    back: 'Back',
    done: 'Done',
    copy: 'Copy',
    export: 'Export',
    view: 'View',
    open: 'Open',
    rename: 'Rename',
    clear: 'Clear',
    apply: 'Apply',
    select: 'Select',
    submit: 'Submit',
    logOut: 'Log out',
  },
  states: {
    loading: 'Loading…',
    saving: 'Saving…',
    deleting: 'Deleting…',
    creating: 'Creating…',
    uploading: 'Uploading…',
    noResults: 'No results',
    somethingWentWrong: 'Something went wrong',
  },
  notFound: {
    title: 'Page not found',
    description: 'This page does not exist or has moved.',
    home: 'Go to the start page',
  },
  forms: {
    required: 'This field is required',
    invalidEmail: 'Enter a valid email address',
    invalidValue: 'Invalid value',
    somethingWentWrong: 'Something went wrong. Please try again.',
    serverError: 'Something went wrong on our end. Please try again later.',
  },
  switcher: {
    label: 'Language',
  },
};

export type CommonDict = typeof common;
